import { FC } from "react";
import { HeartPulseIcon } from "lucide-react-native";

import { VnBox } from "@/components/VnBox";
import { VnIcon } from "@/components/VnIcon";
import { OnboardingScreenType } from "@/domain/onboarding";
import { useOnboardingConcernsContent } from "@/hooks/useOnboardingConcernsContent";

import concernsBackground from "./assets/concerns-background.jpg";
import { PhotoCardHeader } from "./PhotoCardHeader";
import { PhotoCardRow } from "./PhotoCardRow";
import { PhotoCardStepFrame } from "./PhotoCardStepFrame";

const IMAGE_POSITION = { left: "50%", top: "10%" } as const;

export const PhotoCardConcernsStep: FC<OnboardingScreenType> = layout => {
  const { title, description, options, selectedOption, selectOption } =
    useOnboardingConcernsContent();

  return (
    <PhotoCardStepFrame
      {...layout}
      image={concernsBackground}
      imagePosition={IMAGE_POSITION}>
      <PhotoCardHeader
        icon={<VnIcon as={HeartPulseIcon} size={48} className="text-primary" />}
        title={title}
        description={description}
      />

      <VnBox className="gap-3">
        {options.map(option => (
          <PhotoCardRow
            key={option.id}
            icon={option.icon}
            text={option.text}
            onPress={() => selectOption(option.id)}
            isSelected={selectedOption === option.id}
          />
        ))}
      </VnBox>
    </PhotoCardStepFrame>
  );
};
